export const showHideRelatedOrdersButton = () => {
    const apiKey = document.getElementById("UserIdAPIKeyContainer").innerHTML.trim();
    const apiUrl = document.getElementById("OrdersAPIUrlContainer").innerHTML.trim();
    const relatedOrdersRow = document.querySelector('.related_orders');
    const searchWord = window.location.href.split('?id=')[1].split('&')?.[0];
    const userID = document.getElementById("UserIdContainer").innerHTML.trim();

    const item = {
        UserId: userID,
        APIKey: apiKey,
        SearchWord: searchWord,
        Skip: 0,
        Take: 1,
    };

    fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
    })
    .then(response => {
        if (response.ok) return response.json();
    })
    .then((output) => {
        if (output.Orders != null && output.Orders.length > 0) {
            relatedOrdersRow.classList.remove('hidden');
        }
    });
}